import React from "react";

import { Plus } from "lucide-react";

import {
  ExperimentType,
  contentByExperimentType,
} from "./researchFoundation.constants";

interface CoreResearchQuestionsProps {
  questions: string[];
  onChange: (questions: string[]) => void;
  experimentType: ExperimentType;
}

export const CoreResearchQuestions: React.FC<CoreResearchQuestionsProps> = ({
  questions,
  onChange,
  experimentType,
}) => {
  const config = contentByExperimentType[experimentType];
  const maxQuestions = 3;

  const handleQuestionChange = (index: number, value: string) => {
    const next = [...questions];
    next[index] = value;
    onChange(next);
  };

  const handleAddQuestion = () => {
    if (questions.length < maxQuestions) {
      onChange([...questions, ""]);
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-white">
            Core Research Questions
          </span>
          <span className="text-xs text-white/40">
            ({questions.length}/{maxQuestions})
          </span>
        </div>
      </div>

      <div className="space-y-3">
        {questions.map((question, index) => (
          <div key={index} className="space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-xs text-white/60">
                Question {index + 1}
              </span>
            </div>
            <textarea
              value={question}
              onChange={(e) => handleQuestionChange(index, e.target.value)}
              placeholder={
                config.coreQuestions.placeholders[index] ||
                "What specific question must this experiment answer?"
              }
              rows={2}
              className="w-full resize-none rounded-md border border-white/20 bg-white/5 px-3 py-2 text-sm text-white placeholder:text-white/40 focus:border-amber-400/50 focus:outline-none"
            />
          </div>
        ))}
      </div>

      {questions.length < maxQuestions && (
        <button
          type="button"
          onClick={handleAddQuestion}
          className="inline-flex items-center rounded-md px-2 py-1 text-sm text-white/60 hover:bg-white/10 hover:text-white"
        >
          <Plus size={14} className="mr-1" />
          Add question
        </button>
      )}

      <p className="text-xs text-white/50">
        What specific questions must this experiment answer? Focus on questions
        that directly inform your decisions.
      </p>
    </div>
  );
};
